<template>
  <Modal title="调课件" v-model="visible">
    <Form ref="lessonForm" class="form"
      :model="lessonParam" :rules="lessonRule"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="原课件信息">
            <label>等级：<b>{{ lessonOpened.levelTitle }}</b> 课程：<b>{{ lessonOpened.lessonTitle }}</b></label>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始Level" prop="levelId">
            <Select v-model.number="lessonParam.levelId" @on-change="changeLevel" filterable transfer>
              <Option v-for="item in bookMaterialLevelList"
                :value="item.id" :key="item.id">{{ item.title }}(版本{{item.materialVersion}})</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始课程" prop="lessonId">
            <Select v-model.number="lessonParam.lessonId" filterable transfer>
              <Option v-for="item in bookMaterialLessonsList"
                :value="item.id" :key="item.id">{{ item.title }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="是否顺延">
            <RadioGroup v-model="lessonParam.postpone">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingChange" @click="change">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'ChangeLessonModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      lessonOpened: {
        type: Object,
        default: {
          levelTitle: '',
          lessonTitle: ''
        }
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        bookMaterialLevelList: null,
        bookMaterialLessonsList: null,
        lessonParam: {
          levelId: null,
          lessonId: null,
          postpone: 1
        },
        isInit: true,
        loadingChange: false,
        lessonRule: {
          levelId: [
            { type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur' }
          ],
          lessonId: [
            { type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      changeLevel (val) {
        if (!val) return
        let self = this
        self.lessonParam.lessonId = ''
        self.bookMaterialLessonsList = null
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLessonsList = res.data
          if (self.isInit) {
            let lessonId = self.lessonOpened.lessonId
            self.lessonParam.lessonId = lessonId
          }
          self.isInit = false
        })
      },
      change () {
        let self = this
        self.loadingChange = true
        self.$refs.lessonForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingChange = false
            return
          }
          let params = {}
          params.openedId = self.lessonOpened.id
          params.lessonId = self.lessonParam.lessonId
          params.postpone = self.lessonParam.postpone
          self.$http.post('/bookLesson/changeLesson', params).then(function (res) {
            self.loadingChange = false
            if (res) {
              self.$Message.success('调课件成功!')
              self.successCallback()
              self.visible = false
              return
            }
          })
        })
      },
      loadBookMaterialLevel () {
        let self = this
        if (self.bookMaterialLevelList) {
          let levelId = self.lessonOpened.levelId
          self.lessonParam.levelId = parseInt(levelId)
          return
        }
        self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=' + self.lessonOpened.lsnType).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLevelList = res.data
          let levelId = self.lessonOpened.levelId
          self.lessonParam.levelId = parseInt(levelId)
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.isInit = true
          this.lessonParam.postpone = 1
          this.loadBookMaterialLevel()
        } else {
          this.bookMaterialLessonsList = null
          this.bookMaterialLevelList = null
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ChangeLessonModal.vue?51d1902b